import ContentOverlay from "../components/content_overlay";
import { Link } from "react-router-dom";

function ReferencesPage() {
  return (
    <ContentOverlay
      heading={
        <h2
          style={{
            textAlign: "center",
            fontFamily: "Nunito",
          }}
        >
          {" "}
          <b>References</b>
        </h2>
      }
      text_content={
        <div>
          <p
            className="container"
            style={{
              fontSize: "0.8em",
              fontFamily: "Nunito",
            }}
          >
            <p>
              [1] Caspeta L, Buijs NAA, Nielsen J. The role of biofuels in the
              future energy supply. Energy &amp; Environmental Science
              2013;6:1077. doi:10.1039/c3ee24403b.
            </p>
            <p>
              [2] Ullah K, Ahmad M, Sofia, Sharma VK, Lu P, Harvey A, et al.
              Algal biomass as a global source of transport fuels: Overview and
              development perspectives. Progress in Natural Science: Materials
              International 2014;24:329&ndash;39.
              doi:10.1016/j.pnsc.2014.06.008.
            </p>
            <p>
              [3] Ramachandra T V., Aithal BH, Sreejith K. GHG footprint of
              major cities in India. Renewable and Sustainable Energy Reviews
              2015;44:473&ndash;95. doi:10.1016/j.rser.2014.12.036.
            </p>
            <p>
              [4] Edenhofer O, Pichs-Madruga R, Sokona Y, Kadner S, Minx J,
              Brunner S, et al. Technical Summary. Jan Fuglestvedt Edgar
              Hertwich Elmar Kriegler; 2014. doi:10.1103/PhysRevD.70.106002.
            </p>
            <p>
              [5] Friedlingstein P, Andrew RM, Rogelj J, Peters GP, Canadell JG,
              Knutti R, et al. Persistent growth of CO<sub>2</sub> emissions and
              implications for reaching climate targets. Nature Geoscience 2014
              7:10 2014;7:709&ndash;15. doi:10.1038/ngeo2248.
            </p>
            <p>
              [6] Luo X, Chen K, Li H, Wang C. The capture and simultaneous
              fixation of CO2 in the simulation&nbsp;of&nbsp;fuel gas by
              bifunctionalized ionic liquids. International Journal of Hydrogen
              Energy 2016;41:9175&ndash;82. doi:10.1016/J.IJHYDENE.2015.12.223.
            </p>
            <p>
              [7] Patel A, Gami B, Patel P, Patel B. Microalgae: Antiquity to
              era of integrated technology. Renewable and Sustainable Energy
              Reviews 2017;71:535&ndash;47. doi:10.1016/J.RSER.2016.12.081.
            </p>
            <p>
              [8] Ummalyma SB, Sahoo D, Pandey A. Resource recovery through
              bioremediation of wastewaters and waste carbon by microalgae: a
              circular bioeconomy approach. Environmental Science and Pollution
              Research International 2021;28:58837&ndash;56.
              doi:10.1007/S11356-020-11645-8.
            </p>
            <p>
              [9] Yadav G, Dash SK, Sen R. A biorefinery for valorization of
              industrial wastewater and flue gas by microalgae for waste
              mitigation, carbon-dioxide sequestration and algal biomass
              production. Science of The Total Environment
              2019;688:129&ndash;35. doi:10.1016/J.SCITOTENV.2019.06.024.
            </p>
            <p>
              [10] Sheehan J, Dunahay T, Benemann J, Roessler P. Look Back at
              the U.S. Department of Energy&rsquo;s Aquatic Species Program:
              Biodiesel from Algae; Close-Out Report. 1998.
              doi:10.2172/15003040.
            </p>
            <p>
              [11] Levitan O, Dinamarca J, Hochman G, Falkowski PG. Diatoms: A
              fossil fuel of the future. Trends in Biotechnology
              2014;32:117&ndash;24. doi:10.1016/j.tibtech.2014.01.004.
            </p>
            <p>
              [12] Hildebrand M, Davis AK, Smith SR, Traller JC, Abbriano R. The
              place of diatoms in the biofuels industry. Biofuels
              2012;3:221&ndash;40. doi:10.4155/bfs.11.157.
            </p>
            <p>
              [13] Ramachandra T V., Mahapatra DM, B K, Gordon R. Milking
              Diatoms for Sustainable Energy: Biochemical Engineering versus
              Gasoline-Secreting Diatom Solar Panels. Industrial &amp;
              Engineering Chemistry Research 2009;48:8769&ndash;88.
              doi:10.1021/ie900044j.
            </p>
            <p>
              [14] Wang J-K, Seibert M. Prospects for commercial production of
              diatoms. Biotechnology for Biofuels 2017;10:16.
              doi:10.1186/s13068-017-0699-y.
            </p>
            <p>
              [15] Fields FJ, Kociolek JP. An evolutionary perspective on
              selecting high-lipid-content diatoms (Bacillariophyta). Journal of
              Applied Phycology 2015;27:2209&ndash;20.
              doi:10.1007/s10811-014-0505-1.
            </p>
            <p>
              [16] Urbani R, Sist P, Pletikapic G, Misic T, Svetlicic V, Zutic
              V. Diatom Polysaccharides: Extracellular Production, Isolation and
              Molecular Characterization. The Complex World of Polysaccharides,
              InTech; 2012. doi:10.5772/51251.
            </p>
            <p>
              [17] Marella TK, L&oacute;pez-Pacheco IY, Parra-Sald&iacute;var R,
              Dixit S, Tiwari A. Wealth from waste: Diatoms as tools for
              phycoremediation of wastewater and for obtaining value from the
              biomass. Science of the Total Environment 2020;724:137960.
              doi:10.1016/j.scitotenv.2020.137960.
            </p>
            <p>
              [18] Hu Q, Sommerfeld M, Jarvis E, Ghirardi M, Posewitz M, Seibert
              M, et al. Microalgal triacylglycerols as feedstocks for biofuel
              production: Perspectives and advances. Plant Journal
              2008;54:621&ndash;39. doi:10.1111/j.1365-313X.2008.03492.x.
            </p>
            <p>
              [19] Mantzorou A, Ververidis F. Microalgal biofilms: A further
              step over current microalgal cultivation techniques. Science of
              The Total Environment 2019;651:3187&ndash;201.
              doi:10.1016/J.SCITOTENV.2018.09.355.
            </p>
            <p>
              [20] Katarzyna L, Sai G, Singh OA. Non-enclosure methods for
              non-suspended microalgae cultivation: literature review and
              research needs. Renewable and Sustainable Energy Reviews
              2015;42:1418&ndash;27. doi:10.1016/J.RSER.2014.11.029.
            </p>
            <p>
              [21] Shen Y, Xu X, Zhao Y, Lin X. Influence of algae species,
              substrata and culture conditions on attached microalgal culture.
              Bioprocess and Biosystems Engineering 2014;37:441&ndash;50.
              doi:10.1007/s00449-013-1011-6.
            </p>
            <p>
              [22] Palma H, Killoran E, Sheehan M, Berner F, Heimann K.
              Assessment of microalga biofilms for simultaneous remediation and
              biofuel generation in mine tailings water. Bioresource Technology
              2017;234:327&ndash;35. doi:10.1016/J.BIORTECH.2017.03.063.
            </p>
            <p>
              [23] Berner F, Heimann K, Sheehan M. Microalgal biofilms for
              biomass production. Journal of Applied Phycology
              2015;27:1793&ndash;804. doi:10.1007/s10811-014-0489-x.
            </p>
            <p>
              [24] Zippel B, Neu TR. Growth and structure of phototrophic
              biofilms under controlled light conditions. Water Science and
              Technology 2005;52:203&ndash;9. doi:10.2166/wst.2005.0202.
            </p>
            <p>
              [25] Zippel B, Rijstenbil J, Neu TR. A flow-lane incubator for
              studying freshwater and marine phototrophic biofilms. Journal of
              Microbiological Methods 2007;70:336&ndash;45.
              doi:10.1016/J.MIMET.2007.05.013.
            </p>
            <p>
              [26] Boelee NC, Janssen M, Temmink H, Taparavičiūtė L, Khiewwijit
              R, J&aacute;noska &Aacute;, et al. The effect of harvesting on
              biomass production and nutrient removal in phototrophic biofilm
              reactors for effluent polishing n.d.
              doi:10.1007/s10811-013-0178-1.
            </p>
            <p>
              [27] Ozkan A, Kinney K, Katz L, Berberoglu H. Reduction of water
              and energy requirement of algae cultivation using an algae biofilm
              photobioreactor. Bioresource Technology 2012;114:542&ndash;8.
              doi:10.1016/j.biortech.2012.03.055.
            </p>
            <p>
              [28] Zhang Q, Li X, Guo D, Ye T, Xiong M, Zhu L, et al. Operation
              of a vertical algal biofilm enhanced raceway pond for nutrient
              removal and microalgae-based byproducts production under different
              wastewater loadings. Bioresource Technology 2018;253:323&ndash;32.
              doi:10.1016/J.BIORTECH.2018.01.014.
            </p>
            <p>
              [29] Shen Y, Wang S, Ho S-H, Xie Y, Chen J. Enhancing lipid
              production in attached culture of a thermotolerant microalga
              Desmodesmus sp. F51 using light-related strategies. Biochemical
              Engineering Journal 2018;129:119&ndash;28.
              doi:10.1016/J.BEJ.2017.09.017.
            </p>
            <p>
              [30] Gross M, Henry W, Michael C, Wen Z. Development of a rotating
              algal biofilm growth system for attached microalgae growth with in
              situ biomass harvest. Bioresource Technology
              2013;150:195&ndash;201. doi:10.1016/J.BIORTECH.2013.10.016.
            </p>
            <p>
              [31] Podola B, Li T, Melkonian M. Porous Substrate Bioreactors: A
              Paradigm Shift in Microalgal Biotechnology? Trends in
              Biotechnology 2017;35:121&ndash;32.
              doi:10.1016/j.tibtech.2016.06.004.
            </p>
            <p>
              [32] Lebeau T, Gaudin P, Moan R, Robert JM. A new photobioreactor
              for continuous marennin production with a marine diatom: Influence
              of the light intensity and the immobilised-cell matrix (alginate
              beads or agar layer). Applied Microbiology and Biotechnology
              2002;59:153&ndash;9. doi:10.1007/s00253-002-0993-9.
            </p>
            <p>
              [33] Adey WH, Kangas PC, Mulbry W. Algal Turf Scrubbing: Cleaning
              Surface Waters with Solar Energy while Producing a Biofuel.
              BioScience 2011;61:434&ndash;41. doi:10.1525/bio.2011.61.6.5.
            </p>
            <p>
              [34] Adey WH, Laughinghouse HD, Miller JB, Hayek LAC, Thompson JG,
              Bertman S, et al. Algal turf scrubber (ATS) floways on the Great
              Wicomico River, Chesapeake Bay: Productivity, algal community
              structure, substrate and chemistry1. Journal of Phycology
              2013;49:489&ndash;501. doi:10.1111/jpy.12056.
            </p>
            <p>
              [35] Craggs RJ, McAuley PJ, Smith VJ. Wastewater nutrient removal
              by marine microalgae grown on a corrugated raceway. Water Research
              1997;31:1701&ndash;7. doi:10.1016/S0043-1354(96)00093-0.
            </p>
            <p>
              [36] Popovich CA, Pistonesi M, Hegel P, Constenla D, Bielsa GB,
              Mart&iacute;n LA, et al. Unconventional alternative biofuels:
              Quality assessment of biodiesel and its blends from marine diatom
              Navicula cincta. Algal Research 2019;39:101438.
              doi:10.1016/J.ALGAL.2019.101438.
            </p>
            <p>
              [37] Rajaram MG, Nagaraj S, Manjunath M, Boopathy AB, Kurinjimalar
              C, Rengasamy R, et al. Biofuel and biochemical analysis of amphora
              coffeaeformis RR03, a novel marine diatom, cultivated in an open
              raceway pond. Energies 2018;11:1&ndash;12. doi:10.3390/en11061341.
            </p>
            <p>
              [38] Mart&iacute;n LA, Popovich CA, Mart&iacute;nez AM, Scodelaro
              Bilbao PG, Damiani MC, Leonardi PI. Hybrid two-stage culture of
              Halamphora coffeaeformis for biodiesel production: Growth phases,
              nutritional stages and biorefinery approach. Renewable Energy
              2018. doi:10.1016/j.renene.2017.10.086.
            </p>
            <p>
              [39] Saranya G, Subashchandran MD, Mesta P, Ramachandra T V.
              Prioritization of prospective third-generation biofuel diatom
              strains. Energy, Ecology and Environment 2018;3:338&ndash;54.
              doi:10.1007/s40974-018-0105-z.
            </p>
            <p>
              [40] Mathimani T, Mallick N. A comprehensive review on harvesting
              of microalgae for biodiesel &ndash; Key challenges and future
              directions. Renewable and Sustainable Energy Reviews
              2018;91:1103&ndash;20. doi:10.1016/J.RSER.2018.04.083.
            </p>
            <p>
              [41] Milledge JJ, Heaven S. A review of the harvesting of
              micro-algae for biofuel production. Reviews in Environmental
              Science and Bio/Technology 2013;12:165&ndash;78.
              doi:10.1007/s11157-012-9301-z.
            </p>
            <p>
              [42] Shahid A, Malik S, Zhu H, Xu J, Nawaz MZ, Nawaz S, et al.
              Cultivating microalgae in wastewater for biomass production,
              pollutant removal, and atmospheric carbon mitigation; a review.
              Science of the Total Environment 2020;704:135303.
              doi:10.1016/j.scitotenv.2019.135303.
            </p>
            <p>
              [43] Ramachandra T V, Hegde G. Energy Trajectory in India:
              Challenges and Opportunities for Innovation. Journal of Resources,
              Energy and Development 2015;12:1&ndash;24. doi:10.3233/RED-120115.
            </p>
            <p>
              [44] Irwin NB, Irwin EG, Martin JF, Aracena P. Constructed
              wetlands for water quality improvements: Benefit transfer analysis
              from Ohio. Journal of Environmental Management
              2018;206:1063&ndash;71. doi:10.1016/J.JENVMAN.2017.10.050.
            </p>
            <p>
              [45] Dayana Priyadharshini S, Suresh Babu P, Manikandan S,
              Subbaiya R, Govarthanan M, Karmegam N. Phycoremediation of
              wastewater for pollutant removal: A green approach to
              environmental protection and long-term remediation. Environmental
              Pollution 2021;290:117989. doi:10.1016/J.ENVPOL.2021.117989.
            </p>
            <p>
              [46] Ramachandra T V., Sudarshan PB, Mahesh MK, Vinay S. Spatial
              patterns of heavy metal accumulation in sediments and macrophytes
              of Bellandur wetland, Bangalore. Journal of Environmental
              Management 2018;206:1204&ndash;10.
              doi:10.1016/j.jenvman.2017.10.014.
            </p>
            <p>
              [47] Craggs RJ, Adey WH, Jenson KR, St. John MS, Green FB, Oswald
              WJ. Phosphorus removal from wastewater using an algal turf
              scrubber. Water Science and Technology 1996;33:191&ndash;8.
              doi:10.1016/0273-1223(96)00354-X.
            </p>
            <p>
              [48] Ramachandra T V., Joshi N V., Subramanian DK. Present and
              prospective role of bioenergy in regional energy system. Renewable
              and Sustainable Energy Reviews 2000;4:375&ndash;430.
              doi:10.1016/S1364-0321(00)00002-2.
            </p>
            <p>
              [49] Ramachandra T V., Durga Madhab M, Shilpi S, Joshi N V. Algal
              biofuel from urban wastewater in India: Scope and challenges.
              Renewable and Sustainable Energy Reviews 2013;21:767&ndash;77.
              doi:10.1016/j.rser.2012.12.029.
            </p>
            <p>
              [50] Saranya G, Ramachandra T V. Substrata Wise Benthic Diatom
              Community Structure of Aganashini Estuary, Uttara Kannada
              District. Substrata Wise Benthic Diatom Community Structure of
              Aganashini Estuary, Uttara Kannada District, 2016.
            </p>
            <p>
              [51] Ramchandran TV, Gunasekaran S. Sustainable Biofuel Production
              From Estuarine Diatoms. Green Chemistry &amp; Technology Letters
              2020;6:01&ndash;17. doi:10.18510/gctl.2020.621.
            </p>
            <p>
              [52] Axelsson M, Gentili F. A single-step method for rapid
              extraction of total lipids from green microalgae. PLoS ONE
              2014;9:e89643. doi:10.1371/journal.pone.0089643.
            </p>
            <p>
              [53] Saranya G, Ramachandra TV. Novel Biocatalyst for Optimal
              Biodiesel Production from Diatoms. Renewable Energy 2020.
              doi:10.1016/j.renene.2020.02.053.
            </p>
            <p>
              [54] Guillard, Ryther. f/2 Medium for growing diatoms : 2L Recipe.
              Techniques 2005:2005.
            </p>
            <p>
              [55] Strickland JDH, Parsons TR. A practical handbook of seawater
              analysis. Bulletin 167. Fisheries Research Board of Canada
              Bulletin 1972;167:310.
            </p>
            <p>
              [56] Gross M, Henry W, Michael C, Wen Z. Development of a rotating
              algal biofilm growth system for attached microalgae growth with in
              situ biomass harvest. Bioresource Technology
              2013;150:195&ndash;201. doi:10.1016/J.BIORTECH.2013.10.016.
            </p>
            <p>
              [57] Orr D, Lewis A, Adey WH. Algal Turf Scrubber (ATS) Algae to
              Energy Project 2010:129.
            </p>
            <p>
              [58] Hoekman SK, Broch A, Robbins C, Ceniceros E, Natarajan M.
              Review of biodiesel composition, properties, and specifications.
              Renewable and Sustainable Energy Reviews 2012;16:143&ndash;69.
              doi:10.1016/j.rser.2011.07.143.
            </p>
            <p>
              [59] Saranya G, Ramachandra TV. Life cycle assessment of biodiesel
              from estuarine microalgae. Energy Conversion and Management: X
              2020;8:100065. doi:10.1016/j.ecmx.2020.100065.
            </p>
            <p>
              [60] Rodrigues A, Bordado JC, Dos Santos RG. Upgrading the
              glycerol from biodiesel production as a source of energy carriers
              and chemicals - A technological review for three chemical
              pathways. Energies 2017;10. doi:10.3390/en10111817.
            </p>
            <p>
              [61] Harun R, Davidson M, Doyle M, Gopiraj R, Danquah M, Forde G.
              Technoeconomic analysis of an integrated microalgae
              photobioreactor, biodiesel and biogas production facility. Biomass
              and Bioenergy 2011;35:741&ndash;7.
              doi:10.1016/j.biombioe.2010.10.007.
            </p>
            <p>
              [62] Ramachandra T V., Shruthi B V. Spatial mapping of renewable
              energy potential. Renewable and Sustainable Energy Reviews
              2007;11:1460&ndash;80. doi:10.1016/j.rser.2005.12.002.
            </p>
            <p>
              [63] Renuka N, Ratha SK, Kader F, Rawat I, Bux F. Insights into
              the potential impact of algae-mediated wastewater beneficiation
              for the circular bioeconomy: A global perspective. Journal of
              Environmental Management 2021;297:113257.
              doi:10.1016/J.JENVMAN.2021.113257.
            </p>
            <p>
              [64] Venkata Mohan S, Hemalatha M, Chakraborty D, Chatterjee S,
              Ranadheer P, Kona R. Algal biorefinery models with
              self-sustainable closed loop approach: Trends and prospective for
              blue-bioeconomy. Bioresource Technology 2020;295:122128.
              doi:10.1016/J.BIORTECH.2019.122128.
            </p>
            <p>
              [65] Guldhe A, Ansari FA, Singh P, Bux F. Heterotrophic
              cultivation of microalgae using aquaculture wastewater: A
              biorefinery concept for biomass production and nutrient
              remediation. Ecological Engineering 2017;99:47&ndash;53.
              doi:10.1016/j.ecoleng.2016.11.013.
            </p>
            <p>
              [66] Nagarajan D, Lee DJ, Chen CY, Chang JS. Resource recovery
              from wastewaters using microalgae-based approaches: A circular
              bioeconomy perspective. Bioresource Technology 2020;302:122817.
              doi:10.1016/J.BIORTECH.2020.122817.
            </p>
            <p>
              [67] Jankowska E, Sahu AK, Oleskowicz-Popiel P. Biogas from
              microalgae: Review on microalgae&rsquo;s cultivation, harvesting
              and pre-treatment for anaerobic digestion. Renewable and
              Sustainable Energy Reviews 2017;75:692&ndash;709.
              doi:10.1016/J.RSER.2016.11.045.
            </p>
            <p>
              [68] Ezeji TC, Qureshi N, Blaschek HP. Bioproduction of butanol
              from biomass: from genes to bioreactors. Current Opinion in
              Biotechnology 2007;18:220&ndash;7.
              doi:10.1016/j.copbio.2007.04.002.
            </p>
            <p>
              [69] Elliott DC, Hart TR, Schmidt AJ, Neuenschwander GG, Rotness
              LJ, Olarte M V., et al. Process development for hydrothermal
              liquefaction of algae feedstocks in a continuous-flow reactor.
              Algal Research 2013;2:445&ndash;54.
              doi:10.1016/J.ALGAL.2013.08.005.
            </p>
            <p>
              [70] Dote Y, Sawayama S, Inoue S, Minowa T, Yokoyama S. Recovery
              of liquid fuel from hydrocarbon-rich microalgae by thermochemical
              liquefaction. Fuel 1994;73:1855&ndash;7.
              doi:10.1016/0016-2361(94)90211-9.
            </p>
            <p>
              [71] Stephens E, Ross IL, Mussgnug JH, Wagner LD, Borowitzka MA,
              Posten C, et al. Future prospects of microalgal biofuel production
              systems. Trends in Plant Science 2010;15:554&ndash;64.
              doi:10.1016/J.TPLANTS.2010.06.003.
            </p>
            <p>
              [72] Wiley P, Harris L, Reinsch S, Tozzi S, Embaye T, Clark K, et
              al. Microalgae Cultivation Using Offshore Membrane Enclosures for
              Growing Algae (OMEGA). Journal of Sustainable Bioenergy Systems
              2013;03:18&ndash;32. doi:10.4236/jsbs.2013.31003.
            </p>
            <p>
              [73] Dewangan A, Yadav AK, Mallick A. Current scenario of
              biodiesel development in India: prospects and challenges. Energy
              Sources, Part A: Recovery, Utilization and Environmental Effects
              2018;40:2494&ndash;501. doi:10.1080/15567036.2018.1502849.
            </p>
            <p>
              [74] Hoh D, Watson S, Kan E. Algal biofilm reactors for integrated
              wastewater treatment and biofuel production: A review. Chemical
              Engineering Journal 2016;287:466&ndash;73.
              doi:10.1016/J.CEJ.2015.11.062.
            </p>
            <p>
              [75] Lin YF, Jing SR, Lee DY, Wang TW. Nutrient removal from
              aquaculture wastewater using a constructed wetlands system.
              Aquaculture 2002;209:169&ndash;84.
              doi:10.1016/S0044-8486(01)00801-8.
            </p>
            <p>
              [76] Henry EC. Handbook of Microalgal Culture: Biotechnology and
              Applied Phycology. vol. 40. John Wiley &amp; Sons; 2004.
              doi:10.1111/j.1529-8817.2004.40502.x.
            </p>
            <p>
              [77] Lin L, Cunshan Z, Vittayapadung S, Xiangqian S, Mingdong D.
              Opportunities and challenges for biodiesel fuel. Applied Energy
              2011;88:1020&ndash;31. doi:10.1016/j.apenergy.2010.09.029.
            </p>
            <p>
              [78] Lymbery AJ, Doup&eacute; RG, Bennett T, Starcevich MR.
              Efficacy of a subsurface-flow wetland using the estuarine sedge
              Juncus kraussii to treat effluent from inland saline aquaculture.
              Aquacultural Engineering 2006;34:1&ndash;7.
              doi:10.1016/j.aquaeng.2005.03.004.
            </p>
            <p>
              [79] Borowitzka MA, Moheimani NR. Sustainable biofuels from algae.
              Mitigation and Adaptation Strategies for Global Change
              2013;18:13&ndash;25. doi:10.1007/s11027-010-9271-9.
            </p>
            <p>
              [80] Silva AG, Carter R, Merss FLM, Corr&ecirc;a DO, Vargas JVC,
              Mariano AB, et al. Life cycle assessment of biomass production in
              microalgae compact photobioreactors. GCB Bioenergy
              2015;7:184&ndash;94. doi:10.1111/gcbb.12120.
            </p>
            <p>
              [81] Singh G, Patidar SK. Microalgae harvesting techniques: A
              review. Journal of Environmental Management
              2018;217:499&ndash;508. doi:10.1016/j.jenvman.2018.04.010.
            </p>
            <p>
              [82] Mata TM, Martins AA, Caetano NS. Microalgae for biodiesel
              production and other applications: A review. Renewable and
              Sustainable Energy Reviews 2010;14:217&ndash;32.
              doi:10.1016/j.rser.2009.07.020.
            </p>
            <br />
            <hr />
            <br />
          </p>
        </div>
      }
    />
  );
}
export default ReferencesPage;
